import React from 'react';
import { USER_DATA } from '../services/storageService/storageKeys';
import { storageService } from "../services/storageService/storageService";


const AuthContext = React.createContext();

export const AuthProvider = ({ children }) => {

  const [user, setUser] = React.useState(null);
  const [token, setToken] = React.useState(null);

  React.useEffect(() => {
    let user = storageService.getData(USER_DATA);
    if (user) login(user);
  }, []);

  const login = (data) => {
    setToken(data.token);
    setUser(data.user);
    storageService.setData(USER_DATA, data);
  };

  const logout = () => {
    storageService.clearAllData();
    setUser(null);
    setToken(null);
  }

  const updateUserData = (newData) => {
    const session = storageService.getData(USER_DATA) || {};
    const newUser = { ...(session.user || user), ...newData };
    storageService.setData(USER_DATA, { ...session, user: newUser });
    setUser(newUser);
  };

  return(
    <AuthContext.Provider value={{ token, user, login, logout, updateUserData }}>
      { children }
    </AuthContext.Provider>
  )
};

export const useAuth = () => {
  return React.useContext(AuthContext);
}